import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
      <path
        fill="currentColor"
        fillOpacity="1"
        d="M3.885 13.25a2.376 2.376 0 014.48 0h8.052v1.583H8.365a2.376 2.376 0 01-4.48 0H.583V13.25h3.302zm4.75-5.542a2.376 2.376 0 014.48 0h3.302v1.584h-3.302a2.376 2.376 0 01-4.48 0H.583V7.708h8.052zm-4.75-5.541a2.376 2.376 0 014.48 0h8.052V3.75H8.365a2.376 2.376 0 01-4.48 0H.583V2.167h3.302zm2.24 1.583a.792.792 0 100-1.583.792.792 0 000 1.583zm4.75 5.542a.792.792 0 100-1.584.792.792 0 000 1.584zm-4.75 5.541a.792.792 0 100-1.583.792.792 0 000 1.583z"
      ></path>
    </svg>
  );
}

export default Icon;
